/*eslint-disable */
import React, { Component } from "react";
import { Grid, Segment, Popup, Button, Icon, Label, Pagination } from "semantic-ui-react";
import { Link } from "react-router-dom";
import GridPlaceholder from "./gridPlaceholder";
import RouteManager from "./routeManager";
import ReadAxios from "../../axiosComponent/read";
import OrdersHeader from '../../orderComponent/ordersHeaders';
import MiniPlaceholder from "./miniPlaceHolder";
import VehicleType from "./vehicleType";
import BLrender from "../../common/bl_no";
import { translate } from "react-i18next";
import moment from 'moment';
import 'moment-timezone';
import ListingPageComponent from "./ListingPageComponent";
import LoadingPlaceholder from "../../placeholderComponent/loadingPlaceholder";
import { branch_Ids, vendor_Id } from "../../../utils/constant";
import ReadAxiosRequestAxios from '../../axiosComponent/allAxiosCommonRequest'
import cogoToast from "cogo-toast";
import { DEMAP_INVOICE_ERROR } from "../../../utils/toastMsgConstant";

export class shipmentGridView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listItems: [],
      isFetching: false,
      totalPages: 0,
      currentPage: 1,
      itemCount: 10,
      itemsPerPage: 10,
      setPageValue: 10,
      statusFilter: "",
      searchFilterGrouping: "",
      throttlerError:"",
      tryAgainDisabled:true
    };
  }

  async componentDidMount() {
    // window scroll listener attached
    //let customer_no = localStorage.getItem('customerNumber')
    //let user_id = localStorage.getItem('userId')

    // this.fetchData();
    if (this.props?.pageNoOn) {
      this.setState({ currentPage: this.props.pageNoOn }, () => {
        this.getInitalData(this.props.pageNoOn)
      })
    }
    else
      this.getInitalData(1)
  }

  componentDidUpdate(prevProps) {
    if (this.props?.pageNoOn != prevProps.pageNoOn) {
      this.setState({ currentPage: this.props.pageNoOn }, () => {
        this.getInitalData(this.props.pageNoOn)
      })
    }
  }

  getInitalData = (activePage) => {
    let booking_branch_ids = localStorage.getItem('branchIds')?.length > 0 ? localStorage.getItem('branchIds').toString()
      : ''
    this.setState({
      isFetching: true,
    })
    let vendorId = localStorage.getItem("vendorId")
    ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/broadcast/vendor/${vendorId}?${this.state.searchFilterGrouping}&booking_branch_ids=${booking_branch_ids}&page=${activePage}&limit=${this.state.itemsPerPage}${this.state.statusFilter}` })
      .then((res) => {
          this.setState(
            {
              isFetching: false,
              listItems: res?.data?.result || [],
              totalPages: res?.data?.meta?.totalPages || 0,
            },
          );        
      })
      .catch((err) => {
        if(err?.response?.data?.message){
          this.setState(
            {
              isFetching: false,
              throttlerError: err?.response?.data?.message
            },
          ); 
          setTimeout(()=>{
            this.setState({
              tryAgainDisabled:false
            })
          },2000)
        }
        console.log('err', err);
      });
  }


  handlePaginationChange = (e, { activePage }) => {
    this.setState({ currentPage: activePage })
    this.props.updatePaginationPage(activePage)
    this.getInitalData(activePage);
  }

  handleStatusChange = (data) => {
    if (data.length !== 0) {
      let statusOrder = `&status=${data ? data.join(',') : ""}`
      this.setState({ statusFilter: statusOrder }, () => {
        this.props.updatePaginationPage(1)
        this.getInitalData(1);
      })
    } else {
      let statusOrder = `&status=`
      this.setState({ statusFilter: statusOrder }, () => {
        this.props.updatePaginationPage(1)
        this.getInitalData(1);
      })
    }
    //this.getInitalData(1);
  }

  // scroll listener function
  handleScroll = () => {
    let divInnerHeight = document.getElementsByClassName("style");
    let scrollLimit = 59;
    scrollLimit = scrollLimit + 675 * (this.state.page - 1);
    console.log(scrollLimit, divInnerHeight[0].scrollTop);
    if (
      Math.ceil(
        divInnerHeight[0].scrollTop > scrollLimit || this.state.isFetching
      )
    ) {
      this.setState({ isFetching: true }, () => {
        this.incrementPage();
      });
    }
  };

  // new page increment
  incrementPage = () => {
    if (!this.state.isFetching) return;
    this.fetchMoreListItems();
  };

  fetchMoreListItems = () => {
    this.fetchData();
    this.setState({ isFetching: false }, () => this.incrementPage());
  };

  handleMetaSearch = (payload) => {
    this.state.exportDataFromSearch = payload;
    let url = `bl_no=${payload.bl_no}&vendor_name=${payload.vendor_id}&vehicle_no=${payload.vehicle_no}&delivery_reference_no=${payload.delivery_reference_no}&start_required_on=${payload.required_on}&end_required_on=${payload.end_required_on}&order_reference_no=${payload.order_reference_no}&invoice_no=${payload.invoice_no}&common_order_number=${payload.common_order_number}&route_id=${payload.route_id}&consignor_id=${payload.consignor_id}&consignee_id=${payload.consignee_id}&from_order_created_on=${payload.from_order_created_on}&to_order_created_on=${payload.to_order_created_on}&lr_no=${payload.lr_no}`

    this.setState({ searchFilterGrouping: url }, () => {
      console.log(url)
      this.props.updatePaginationPage(1)
      this.getInitalData(1)
    });


  };

  exporttrueDataGrid = () => {

    let payload = {
      bl_no: this.state?.exportDataFromSearch?.bl_no ? this.state.exportDataFromSearch.bl_no : "",
      vendor_id: this.state?.exportDataFromSearch?.vendor_id ? this.state.exportDataFromSearch.vendor_id : "",
      vehicle_no: this.state?.exportDataFromSearch?.vehicle_no ? this.state.exportDataFromSearch.vehicle_no : "",
      order_reference_no: this.state?.exportDataFromSearch?.order_reference_no ? this.state.exportDataFromSearch.order_reference_no : "",
      common_order_number: this.state?.exportDataFromSearch?.common_order_number ? this.state.exportDataFromSearch.common_order_number : "",
      delivery_reference_no: this.state?.exportDataFromSearch?.delivery_reference_no ? this.state.exportDataFromSearch.delivery_reference_no : "",
      required_on: this.state?.exportDataFromSearch?.required_on ? this.state.exportDataFromSearch.required_on : "",
      end_required_on: this.state?.exportDataFromSearch?.end_required_on ? this.state.exportDataFromSearch.end_required_on : "",
      invoice_no: this.state?.exportDataFromSearch?.invoice_no ? this.state.exportDataFromSearch.invoice_no : "",
      status: this.state?.exportDataFromSearch?.status?.[0] ? this.state.exportDataFromSearch.status[0] : "",
      transporter_lr_no: this.state?.exportDataFromSearch?.transporter_lr_no ? this.state.exportDataFromSearch.transporter_lr_no : "",
      route_id: this.state?.exportDataFromSearch?.route_id ? this.state.exportDataFromSearch.route_id : "",
      consignor_id: this.state?.exportDataFromSearch?.consignor_id ? this.state.exportDataFromSearch.consignor_id : "",
      consignee_id: this.state?.exportDataFromSearch?.consignee_id ? this.state.exportDataFromSearch.consignee_id : "",
      from_order_created_on : this?.state?.exportDataFromSearch?.from_order_created_on ? this.state.exportDataFromSearch.from_order_created_on : "",
      to_order_created_on : this?.state?.exportDataFromSearch?.to_order_created_on ? this.state.exportDataFromSearch.to_order_created_on : "",
      lr_no : this?.state?.exportDataFromSearch?.lr_no ? this.state.exportDataFromSearch.lr_no : "",
    }

    let bookingBranchIds = branch_Ids.length > 0 ? JSON.stringify(branch_Ids.toString()) : "";
    let vendorId = vendor_Id

    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_TA_API_URL}/orders/broadcast/vendor/${vendorId}/excel/export?bl_no=${payload.bl_no}&vendor_name=${payload.vendor_id}&transporter_lr_no=${payload.transporter_lr_no}&vehicle_no=${payload.vehicle_no}&delivery_reference_no=${payload.delivery_reference_no}&start_required_on=${payload.required_on}&end_required_on=${payload.end_required_on}&order_reference_no=${payload.order_reference_no}&invoice_no=${payload.invoice_no}&common_order_number=${payload.common_order_number}&booking_branch_ids=${bookingBranchIds}&status=${payload.status}&route_id=${payload.route_id}&consignor_id=${payload.consignor_id}&consignee_id=${payload.consignee_id}&from_order_created_on=${payload.from_order_created_on}&to_order_created_on=${payload.to_order_created_on}&lr_no=${payload.lr_no}&page=1&limit=10&`,
      method: "get",
      noQ: true
    })
      .then((res) => {
        cogoToast.success(res.data.message);
        if (res?.status == 200) {
          this.setState({ responseReceived: true })
        }
        this.setState({ spinnerLoading: false })
      })
      .catch((err) => {
        if (err?.response?.data?.message)
          cogoToast.error(err.response.data.message);
        else
          cogoToast.error(DEMAP_INVOICE_ERROR);
        this.setState({ spinnerLoading: false })
      });
  }

  render() {
    const { t } = this.props;
    let content = ""

    return (
      <React.Fragment>
        <OrdersHeader
          showStatusFilter={true}
          allotedOrdersStatusShow={this.props.allotedOrdersStatusShow}
          handleMetaSearch={this.handleMetaSearch}
          handleStatusChange={this.handleStatusChange}
          title={t("orders.active_title") || "Active Orders"}
          LinkName="/add-shipment"
          handleSearch={this.handleChange}
          hideFilter={false}
          // importDataGrid={this.importDataGrid}
          // exportDataGrid={this.exportDataGrid}
          exporttrueDataGrid={this.exporttrueDataGrid}
          exportHidden={this.props.exportHidden}
          radioToggle={this.props.radioToggle}
          toggleView={this.props.toggleView}
          toggle={this.props.toggle}
          baseURL={this.props.baseURL}
          hideTransporter={true}
          hideVehicleNumber={true}
          hideRequired={true}
          searchLoading={this.state.isFetching}
        />
        <ListingPageComponent t={t} listItems={this.state.listItems} tryAgainDisabled={this.state.tryAgainDisabled} throttlerError={this.state.throttlerError} shipmentData={this.props.shipmentData} isFetching={this.state.isFetching} path="/active-order-details" />

        <div className="life-cycle w3-white p-2 mt-9">
          <Pagination
            defaultActivePage={this.props.pageNoLast || this.state.currentPage}
            firstItem={null}
            lastItem={null}
            onPageChange={this.handlePaginationChange}
            pointing
            secondary
            totalPages={this.state.totalPages}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default translate("shipment")(shipmentGridView);
